import { DEFAULT_ROLE_SLUG } from 'consts'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { LinkRow } from 'views/common/link-row'

const Wrapper = styled.div`
  padding-bottom: 40px;
`

interface Props {
  categories: any[]
  zone: any
}

export const CategoriesMobile: ComponentType<Props> = ({ categories, zone }) => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          {categories.map((category) => (
            <LinkRow
              key={category.uuid}
              href="/[categorySlug]/[roleSlug]/[zoneSlug]"
              as={`/${category.slug}/${DEFAULT_ROLE_SLUG}/${zone.slug}`}
              title={category.pluralName}
              subtitle={`${category.properties} propiedades`}
              image={category.cover?.thumbnailUrl}
            />
          ))}
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
